"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUiLibraryConfig = exports.useTranslate = exports.getNavLink = exports.getLink = exports.getLocales = exports.getLocalesConfig = exports.useTranslateDefault = void 0;
const react_1 = require("react");
const elements_core_di_1 = require("@hydrogen/elements.core.di");
const defaultLocaleKey_1 = require("./defaultLocaleKey");
const DefaultLink_1 = require("./DefaultLink");
const useTranslateDefault = () => ({
    t: (key) => key, language: '', isoCode: '',
});
exports.useTranslateDefault = useTranslateDefault;
elements_core_di_1.container.bind('Link').toConstantValue(DefaultLink_1.DefaultLink);
elements_core_di_1.container.bind('NavLink').toConstantValue(DefaultLink_1.DefaultLink);
elements_core_di_1.container.bind('uiLibraryLocaleKeys').toConstantValue(defaultLocaleKey_1.defaultLocaleKey);
elements_core_di_1.container.bind('uiLibraryTranslateFn').toFunction(exports.useTranslateDefault);
const setLink = (Link) => elements_core_di_1.container.rebind('Link').toConstantValue(Link);
const setNavLink = (NavLink) => elements_core_di_1.container.rebind('NavLink').toConstantValue(NavLink);
const setLocales = (locales) => elements_core_di_1.container.rebind('uiLibraryLocaleKeys').toConstantValue(locales);
const setTranslateFn = (translateFn) => elements_core_di_1.container.rebind('uiLibraryTranslateFn').toFunction(translateFn);
const getLocalesConfig = () => elements_core_di_1.container.get('uiLibraryLocaleKeys');
exports.getLocalesConfig = getLocalesConfig;
const getLocales = () => (0, react_1.useMemo)(() => (0, exports.getLocalesConfig)(), []);
exports.getLocales = getLocales;
const getLink = () => (0, react_1.useMemo)(() => elements_core_di_1.container.get('Link'), []);
exports.getLink = getLink;
const getNavLink = () => (0, react_1.useMemo)(() => elements_core_di_1.container.get('NavLink'), []);
exports.getNavLink = getNavLink;
const useTranslate = () => elements_core_di_1.container.get('uiLibraryTranslateFn')();
exports.useTranslate = useTranslate;
const setUiLibraryConfig = ({ localKeys = {}, translateFn, Link, NavLink, }) => {
    setLocales(Object.assign(Object.assign({}, defaultLocaleKey_1.defaultLocaleKey), localKeys));
    if (typeof translateFn === 'function')
        setTranslateFn(translateFn);
    if (Link)
        setLink(Link);
    if (NavLink)
        setNavLink(NavLink);
};
exports.setUiLibraryConfig = setUiLibraryConfig;
//# sourceMappingURL=containers.js.map